import { useCallback } from 'react';
import {
  BooleanInput,
  Create,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
} from 'react-admin';
import { slackNotificationWorkflowChoices } from './workflowChoices';

export const SlackNotificationChannelsCreate = () => {
  const transform = useCallback((data: Record<string, unknown>) => {
    const now = new Date();
    return {
      ...data,
      enabled: data.enabled ?? true,
      createdAt: now,
      updatedAt: now,
    };
  }, []);

  return (
    <Create transform={transform}>
      <SimpleForm>
        <SelectInput
          source="workflow"
          label="Workflow"
          choices={slackNotificationWorkflowChoices}
          validate={[required()]}
          fullWidth
        />
        <TextInput
          source="webhookUrl"
          label="Workflow webhook URL"
          helperText="Slack Workflow Builder trigger URL (hooks.slack.com/triggers/...)"
          validate={[required()]}
          fullWidth
          type="password"
        />
        <BooleanInput source="enabled" defaultValue />
      </SimpleForm>
    </Create>
  );
};
